import { Input } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
class AwComponent {
}
AwComponent.ɵfac = function AwComponent_Factory(t) { return new (t || AwComponent)(); };
AwComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AwComponent, inputs: { automationValue: "automationValue" } });
AwComponent.propDecorators = {
    automationValue: [{ type: Input }]
};

if (false) {
    AwComponent.prototype.automationValue;
}

export { AwComponent };

//# sourceMappingURL=aw-hospital-aw-components-lib-aw-parent.js.map